export const RoutePutUsers_userId_Password = "/users/:userId/password";

export interface PayloadPutUsers_userId_Password {
  newPassword: string;
}
